import {PiperProxy} from '@baidu/ku-piper-core';

// 对外提供的proxyName集合
export const ProxyNameMap = {
    // RTE传参相关
    onRteNotifyProxy: 'onRteNotifyProxy', // RTE通知
    editorPluginOptionsProxy: 'editorPluginOptionsProxy', // RTE pluginOptions 传参
    editorOptionsProxy: 'editorOptionsProxy', // RTE editorOptions 传参
    editorCommonOptionsProxy: 'editorCommonOptionsProxy', // RTE commonOptions 传参
    editorStateProxy: 'editorStateProxy', // RTE editorState 传参
    editorCustomOptionsProxy: 'editorCustomOptionsProxy', // RTE customOptions 传参
    pptCustomOptionsProxy: 'pptCustomOptionsProxy', // RTE customOptions 传参（ppt相关）

    commentEditorConfigProxy: 'commentEditorConfigProxy', // 底部评论 config 传参

    noticeEditorPluginOptionsProxy: 'noticeEditorPluginOptionsProxy', // RTE 部门知识库发公告 pluginOptions 传参

    ViewDetailsEditorPluginOptionsProxy: 'ViewDetailsEditorPluginOptionsProxy', // RTE 部门知识库 查看公告详情 pluginOptions 传参

    // 石墨表格传参相关
    onSheetRteNotifyProxy: 'onSheetRteNotifyProxy', // 表格通知
    sheetCommonOptionsProxy: 'sheetCommonOptionsProxy', // 表格 commonOptions 传参

    feLoggerProxy: 'feLoggerProxy', // 埋点上报
    useEntityLinkingProxy: 'useEntityLinkingProxy', // 链指hook
    wideScreenDefault: 'wideScreenDefault', // 初始载入时宽屏模式默认值设定
    applyDocPermissionSuccess: 'applyDocPermissionSuccess', // 申请权限权限成功后插入额外逻辑
    renderKnowledgeContent: 'renderKnowledgeContent', // 渲染侧边栏右侧的内容

    // asServerSetUserProxy: 'asServerSetUserProxy', // as server 设置 this.user 的值
    loadWaterMarkSdkProxy: 'loadWaterMarkSdkProxy', // 加载水印sdk
    // 搜索的过滤配置默认值
    searchFilterDefaultOptions: 'searchFilterDefaultOptions',
    // landingPageLinkAddress: 'landingPageLinkAddress', // 落地页链接地址

    getUserIntelligentSetting: 'getUserIntelligentSetting', // 全局设置-获取设置项
    changeUserIntelligentSetting: 'onChangeUserIntelligentSetting', // 全局设置-智能推荐选项改变的回调函数

    // 跳转个人知识库proxy - 目前支持 1、首页跳转 2、顶栏头像跳转 3、头像下拉菜单跳转
    // 起初我是真的想把这三个合成一个的！！但是那边pm的逻辑是让这三个彼此独立，每个的处理逻辑要分开……最后含泪开了3个……T^T
    homeToMyPersonalRepoJump: 'homeToMyPersonalRepoJump', // 首页-跳转我的个人知识库
    avatarToMyPersonalRepoJump: 'avatarToMyPersonalRepoJump', // 顶栏头像-跳转我的个人知识库
    avatarMenuToMyPersonalRepoJump: 'avatarMenuToMyPersonalRepoJump', // 顶栏头像下拉菜单-跳转我的个人知识库

    // 各种链接跳转
    headerLogoClickJump: 'headerLogoClickJump',
    headerRepoSelectClickJump: 'headerRepoSelectClickJump',
    treeNodeClickJump: 'treeNodeClickJump', // 目录树节点点击跳转【仅当节点ignoreClick为true时生效】
    treeCommonDocClickJump: 'treeCommonDocClickJump', // 目录树常用页面点击跳转
    docTagClickJump: 'docTagClickJump', // 文档标签点击跳转
    sidebarSearchClickJump: 'sidebarSearchClickJump', // 侧边栏目录树搜索结果跳转
    createDocUrlJump: 'createDocUrlJump', // 创建新文档成功后的跳转
    deleteDocUrlJump: 'deleteDocUrlJump', // 删除文档成功后的跳转
    recommendClickJump: 'recommendClickJump', // 推荐文档链接的点击跳转
    docReferenceClickJump: 'docReferenceClickJump', // 双向引用链接的点击跳转
    pageCommentUrlClickJump: 'pageCommentUrlClickJump', // 全文评论中的链接点击跳转
    shareModalMemberClickJump: 'shareModalMemberClickJump', // 分享协作弹窗 -> 知识库成员入口 点击跳转
    entityLinkUrlClickJump: 'entityLinkUrlClickJump', // 星链弹窗相关链接点击跳转
    entityLinkBaiKeClickJump: 'entityLinkBaiKeClickJump', // 星链弹窗百科按钮点击跳转
    pptLinkClickJump: 'pptLinkClickJump', // PPT内的超链接点击跳转

    // sendRlNotifyProxy
    sendRlNotifyProxy: 'sendRlNotifyProxy', // mention发送如流通知
    storeRlNotifyProxy: 'storeRlNotifyProxy', // mention存储如流通知
    forwardCommentNotifyProxy: 'forwardCommentNotifyProxy', // 转发评论如流通知

};

// 对外提供的proxy集合。  为了防止跟ProxyNameMap对不上，这里改成遍历生成了
export const ProxyMap = (function generateProxyMap() {
    const map: {[key: string]: PiperProxy} = {};
    Object.values(ProxyNameMap).forEach((key: string) => {
        map[key] = new PiperProxy();
    });
    return map;
})();
